import { ConversionTableRow } from './conversion-table-row';
import { ConversionTableColumn } from './conversion-table-column';

export class ConversionTable {

    constructor() {
        this.Rows = [];
        this.Columns = [];
        this.IsUniversal = false;  
    }

    Id: number;
    Name: string;
    Description: string;
    PartnerId?: number;
    IsUniversal: boolean;

    Rows: ConversionTableRow[];
    Columns: ConversionTableColumn[];
}